module.exports = __webpack_public_path__ + "img/picto6.df173f8b.svg";